import React from "react";

const Featurs = ({ data }) => {
  console.log(data);
  return (
    <>
      {/* <div className="max-w-7xl mx-auto mt-16 mb-10 px-8">
        <div className="relative flex justify-center">
          <span className="bg-white px-3 text-4xl font-bold text-center text-gray-900">
            {data?.[2].title}
          </span>
        </div>
        <p className="mt-3 text-base leading-7 text-gray-600  text-center">
          {data?.[2].sub_title}</p>
          <div className="grid md:grid-cols-2 gap-10 mt-10">
          {
             data?.[2].feature.map((data) => (
              <div className="flex gap-4 items-start">
              <span className="text-violet-600 bg-violet-500/10 p-3 rounded-full">
             {data.icon}
              </span>
              <div>
                <h3 className="font-semibold text-lg">{data.title}</h3>
                <p className="mt-1 text-gray-500">
                  {" "}
                  {data.desc}
                </p>
              </div>
            </div>
             ))
          }
        </div>
      </div> */}

<div className="bg-white lg:pt-16 lg:pb-10 py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <div>
            <h2 className="text-lg font-semibold leading-8 tracking-tight text-amber-600">
            Why Choose
            </h2>
            <h2 className=" text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {data?.[2].title}
            </h2>
            <p className="mt-2 text-base leading-7 text-gray-600">
            {data?.[2].sub_title}
            </p>
          </div>
          <dl className="col-span-2 grid grid-cols-1 gap-x-8 gap-y-4 text-base leading-7 text-gray-600 sm:grid-cols-2">
            { data?.[2].feature.map((data, index) => (
              <div key={index} className="relative pl-9">
                <dt className="font-semibold text-gray-900">
                  <svg
                    className="absolute top-1 left-0 h-5 w-5 text-indigo-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {data.title}
                </dt>
                <dd className=" text-justify">  {data.desc}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
    </>
  );
};

export default Featurs;
